import { useEffect } from 'react';

// Root of me.linksanto.io has no content of its own — bounce visitors to
// the marketing site so we don't index a blank page.
export default function Home() {
  useEffect(() => {
    window.location.replace('https://linksanto.io');
  }, []);
  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0a0a0a', color: '#fff', fontFamily: 'system-ui, sans-serif' }}>
      <p style={{ opacity: 0.7 }}>Redirecting…</p>
    </main>
  );
}
